export const useGetMaxNumParagraphsInSection = (section: Section) => {

  let numScoreColumns = 1;

  for (const criteriaInstance of section.criteriaInstances) {

    let criteriaScoreColumns = criteriaInstance.evaluationMethod == "paragraph" && criteriaInstance.paragraphPositionsData ? criteriaInstance.paragraphPositionsData.length : 1;

    if (criteriaScoreColumns > numScoreColumns) {
      numScoreColumns = criteriaScoreColumns;
    }
  }

  let childSections = section.sections ?? [];

  for (const childSection of childSections) {
    let childSectionScoreColumns = useGetMaxNumParagraphsInSection(childSection);

    if (childSectionScoreColumns > numScoreColumns) {
      numScoreColumns = childSectionScoreColumns;
    }
  }


  return numScoreColumns;
}
